import { useRouter } from 'vue-router'

export function useNavigation() {
  const router = useRouter()

  const openOs = (protocolo) => {
    router.push({
      name: 'osUpdate',
      params: { protocolo },
    })
  }

  const navigate = (routeName, paramObj, tab = false) => {
    let route = {
      name: routeName,
    }
    if (paramObj) {
      route.params = paramObj
    }

    if (tab) {
      let routeData = router.resolve({
        name: routeName,
        params: paramObj,
      })
      window.open(routeData.href, '_blank')
      return
    }
    router.push(route)
  }

  return {
    openOs,
    navigate,
  }
}
